/**
 * Clay / Soft-3D shell icons for main nav (secondary bar) + ESS left rail.
 * Uses high-definition multi-color clay renders (not flat mono SVGs).
 * Size prop matches Lucide usage (px); shell FlipTiles pass h-full/w-full to fill the tile.
 */
import React from "react";

const cx = (...parts) => parts.filter(Boolean).join(" ");

const SHELL = "/icons/shell";

function Soft3dIcon({
  src,
  size = 20,
  className = "",
  title,
  strokeWidth,
  absoluteStrokeWidth,
  alt = "",
  ...rest
}) {
  void strokeWidth;
  void absoluteStrokeWidth;
  const px = Number(size) || 20;
  const fillParent = /\bh-full\b|\bw-full\b/.test(className);
  return (
    <img
      src={src}
      width={px}
      height={px}
      alt={title || alt}
      title={title}
      draggable={false}
      className={cx(
        "block shrink-0 pace-soft3d-icon pace-shell-nav-icon object-contain select-none",
        className
      )}
      style={
        fillParent
          ? { width: "100%", height: "100%", maxWidth: "100%", maxHeight: "100%" }
          : { width: px, height: px, maxWidth: px, maxHeight: px }
      }
      {...rest}
    />
  );
}

function makeIcon(src, defaultTitle) {
  function Icon({ size = 18, className = "", title = defaultTitle, ...rest }) {
    return (
      <Soft3dIcon
        src={src}
        size={size}
        className={className}
        title={title}
        alt={title}
        {...rest}
      />
    );
  }
  Icon.displayName = `Icon3d(${defaultTitle})`;
  return Icon;
}

/** My Section / Employee — ID card */
export const Icon3dMySection = makeIcon(`${SHELL}/shell-employee.jpg`, "Employee");
/** Home / dashboard */
export const Icon3dHome = makeIcon(`${SHELL}/shell-home.jpg`, "Home");
/** Profile */
export const Icon3dProfile = makeIcon(`${SHELL}/shell-profile.jpg`, "Profile");
/** Attendance — calendar + clock */
export const Icon3dAttendance = makeIcon(`${SHELL}/shell-attendance.jpg`, "Attendance");
/** Payroll — rupee coin */
export const Icon3dPayroll = makeIcon(`${SHELL}/shell-payroll.jpg`, "Payroll");
/** My Team — people on gear */
export const Icon3dMyTeam = makeIcon(`${SHELL}/shell-myteam.jpg`, "My Team");
/** Quick Panel */
export const Icon3dQuickPanel = makeIcon(`${SHELL}/shell-quickpanel.jpg`, "Quick Panel");
/** Request — clipboard */
export const Icon3dRequest = makeIcon(`${SHELL}/shell-request.jpg`, "Request");
/** Approvals — shield check */
export const Icon3dApprovals = makeIcon(`${SHELL}/shell-approvals.jpg`, "Approvals");
/** Configuration — gears + person */
export const Icon3dConfig = makeIcon(`${SHELL}/shell-config.jpg`, "Configuration");
/** Hiring — resume */
export const Icon3dHiring = makeIcon(`${SHELL}/shell-hiring.jpg`, "Hiring");
/** Assets — boxes */
export const Icon3dAssets = makeIcon(`${SHELL}/shell-assets.jpg`, "Assets");
/** Communication — chat */
export const Icon3dComms = makeIcon(`${SHELL}/shell-comms.jpg`, "Communication");
/** Helpdesk — headset */
export const Icon3dHelpdesk = makeIcon(`${SHELL}/shell-helpdesk.jpg`, "Helpdesk");
/** Roles — shield */
export const Icon3dRoles = makeIcon(`${SHELL}/shell-roles.jpg`, "Roles");
/** Reports — presentation board */
export const Icon3dReports = makeIcon(`${SHELL}/shell-reports.jpg`, "Reports");
/** Settings — gears */
export const Icon3dSettings = makeIcon(`${SHELL}/shell-settings.jpg`, "Settings");
/** Help */
export const Icon3dHelp = makeIcon(`${SHELL}/shell-help.jpg`, "Help");
/** Checklist */
export const Icon3dChecklist = makeIcon(`${SHELL}/shell-checklist.jpg`, "Checklist");
/** Import / export */
export const Icon3dImportExport = makeIcon(`${SHELL}/shell-importexport.jpg`, "Import Export");
